import { Component, Input } from '@angular/core';
import { CardCarouselBanner } from './models/banner.interfaces';

@Component({
  selector: 'idp-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {
  @Input() content = {} as CardCarouselBanner;
}
